import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

type Props = {
  onClose: () => void
  onSubmit: () => void
}

const ArchiveWorkingConditionModal = ({ onClose, onSubmit }: Props) => {
  return (
    <Modal
      illustration={'alert'}
      title={i18n.t('company_settings.general.employment_data.work_conditions.archive_modal.title')}
      description={i18n.t(
        'company_settings.general.employment_data.work_conditions.archive_modal.description'
      )}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button submit>{i18n.t('common.archive')}</Button>
        </>
      }
    />
  )
}

export default ArchiveWorkingConditionModal
